import { AstroNewsViewTransitions } from "@components/AstroViewTransitions"
import NewsCard from "@components/News/NewsCard"
import { utcDateOnly } from "@dashboard-config"
import "@components/News/NewsDetail/styles.css"
import { BackButton } from "@components/SiteShell"
import { sanitizeRichHtml } from "@lib/sanitizeHtml"
import type { SupportedLocale as Lang, NewsItem } from "@site-types/site"

export function NewsDetailPage({ locale, post }: { locale: Lang; post: NewsItem }) {
  const displayDate = post.publishDate ? (utcDateOnly(post.publishDate) ?? "") : ""
  return (
    <div className="news-detail-container container">
      <AstroNewsViewTransitions news={[post]} />
      <div className="back-button">
        <BackButton
          locale={locale}
          page="news"
        />
      </div>
      <article className="post">
        <h1 className="title">{post.title}</h1>
        <p className="date">
          <i className="fa-sharp fa-regular fa-newspaper" />
          {displayDate}
        </p>
        <NewsCard
          locale={locale}
          post={post}
          detail
        />
        <blockquote className="blurb">{post.newsCoverBlurb}</blockquote>
        <div
          className="news-detail-body"
          dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(post.bio) }}
        />
      </article>
    </div>
  )
}
